module.exports = __webpack_public_path__ + "static/media/icon_chevron_right_blue.36795198.svg";